export default "/profile/images/KeyCRM.svg?6a1bc8ec8db4b37da6dd3d3fb15a8a13";